import * as actions from 'actions';
import textEditingMaker from 'reducersMakers/textEditingMaker';

export default textEditingMaker({
  submitType: actions.FORUM_THREAD_CREATE,
  submitSuccessType: actions.FORUM_THREAD_CREATE_SUCCESS,
  submitErrorType: actions.FORUM_THREAD_CREATE_ERROR,
  updateTextType: actions.FORUM_CONTRIBUTE_EDITING_UPDATE_TEXT,
  resetType: actions.FORUM_CONTRIBUTE_EDITING_RESET,
  expandType: actions.FORUM_CONTRIBUTE_EDITING_EXPAND
});



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/textEditing/forumContribute/reducer.js
 **/